var map = {
	"./app_fraud.webp": 63748,
	"./ato_fraud.webp": 92745,
	"./brand_abuse.webp": 31274,
	"./document_forgery.webp": 97034,
	"./kyc_fraud.webp": 51898,
	"./market_fraud.webp": 64587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26960;